module.exports = __webpack_public_path__ + "static/media/SectionPartners_lg_cns.57cb92d0.png";